import React from 'react';
import { Button } from "@deere/fuel-react";
import ClearIcon from '@mui/icons-material/Clear';

const FilterHeader = ({ 
  isFiltered, 
  filterTitle, 
  totalFilteredOrders, 
  onClearFilter,
  filterSource = 'default' // 'latePickup', 'lateDelivery', 'deliveryDateMissing', 'vatDeclarationMissing'
}) => {
  if (!isFiltered) return null;

  return (
    <div className="mb-3">
      <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border bg-white text-black border-green-700">
        <span>{filterTitle}</span>
        {totalFilteredOrders > 0 && (
          <span className="ml-1">({totalFilteredOrders})</span>
        )}
        <Button
          variant="text"
          onClick={onClearFilter}
          size="small"
          className="min-w-0 p-0.5 text-black ml-1.5"
          title="Clear Filter"
        >
          <ClearIcon style={{ fontSize: '14px' }} />
        </Button>
      </div>
    </div>
  );
};

export default FilterHeader;
